module.exports = __webpack_public_path__ + "img/pakj_logo@2x.db7f8047.png";